//----------------------------------------------------Custom add 21.02.25----------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
    const footerBlocks = document.querySelectorAll(".footer-block");

    function fadeInFooter() {
        const scrollPosition = window.innerHeight + window.scrollY;

        footerBlocks.forEach((block, index) => {
            if (scrollPosition > block.offsetTop) {
                setTimeout(() => {
                    block.classList.add("visible");
                }, index * 300);
            }
        });
    }

    window.addEventListener("scroll", fadeInFooter);
    fadeInFooter();
});
